"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailSchema = emailSchema;
exports.updateEmailInputSchema = updateEmailInputSchema;
const zod_1 = require("zod");
function requiredStringSchema(requiredField) {
    return zod_1.z.string({ error: () => requiredField }).min(1, requiredField);
}
function emailSchema(translations) {
    const required = translations.fieldRequired('email');
    return zod_1.z
        .string({ error: () => required })
        .min(1, required)
        .email(translations.invalidEmailForField('email'));
}
function updateEmailInputSchema({ translations, }) {
    return zod_1.z.object({
        clientId: requiredStringSchema(translations.fieldRequired('clientId')),
        email: emailSchema(translations),
        password: requiredStringSchema(translations.fieldRequired('password')).min(8, translations.minCharsN(8, 'password')),
    });
}
//# sourceMappingURL=update-email.js.map